import React from "react";
import useWindowDimensions from "../../services/useWindowDimensions";

const ProgressBar = ({ currentPage }: { currentPage: number }) => {
  const { width } = useWindowDimensions();
  const progress = (currentPage + 1) / 6 * 100;

  if (width > 768) {
    return null; // Hide progress bar on larger screens 
  }

  return (
    <div className="absolute top-[60px] left-0 w-full bg-white h-2 z-var" style={{ "--z": 501 } as React.CSSProperties}>
      <div className="h-full bg-navy-blue transition-all duration-300 ease-in-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
}

export default ProgressBar;